import { Command } from 'commander';
import { WorkflowManager } from '../core/workflow-manager';
import { logger } from '../utils/logger';
import { setupWatchMode } from '../utils/watch-helper';
import { withErrorHandling } from '../utils/error-handler';

export function createRunCommand(): Command {
  const command = new Command('run');

  command
    .description('Run workflow commands')
    .argument('<command>', 'Command to run (init, todo, context, review)')
    .option('-w, --watch', 'Watch for changes (only for todo command)')
    .action(withErrorHandling(async (commandName, options) => {
      const manager = new WorkflowManager();
      
      // Special handling for todo with watch
      if (commandName === 'todo' && options.watch) {
        await setupWatchMode(manager, 'task watcher');
        return;
      }

      // Run the command
      await manager.runCommand(commandName);
    }));

  return command;
}